import styled from 'styled-components';
import { Divider } from 'antd';
import { hideOverflowText, mediaSize } from '../../../styles';


export const ImageWrapper = styled.div`
  margin: 0 10px 0 10px;
  display: flex;
  align-items: center;
`;

export const SmallDivider = styled(Divider)`
  flex-shrink: 0;
  margin: 0;
`;

export const TaskTitleWrap = styled.div`
  ${hideOverflowText};
  min-width: 10px;
  margin-left: 15px;
  text-decoration: ${({ done }) => done ? 'line-through' : ''};
  color: ${({ theme }) => theme.colors.mainDark};
  text-align: start;
`;

export const TaskDueDate = styled.div`
  font-size: 13px;
  padding: 10px;
  width: 135px;
  max-width: 170px;
  margin-left: 15px;
  text-decoration: ${({ done }) => done ? 'line-through' : ''};
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const TaskResponsiblePerson = styled.div`
  margin-right: 7px;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  justify-content: flex-end;
  font-size: 11px;
  width: 160px;
`;

export const ResponsibleUserFullName = styled.div`
  ${hideOverflowText};
  margin-left: 5px;
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.table.mainDark};
`;

export const AssignedUserImageWrap = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
`;

export const TaskLeftSide = styled.div`
  width: 50%; 
  max-width: 50%;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(9, minmax(auto, min-content));
`;

export const TaskCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const TaskRightSide = styled.div`
  display: flex;
  align-items: center;
  margin-right: 7px;
`;

export const TaskWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.borderDarkGray};
  border-radius: 4px;
  box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.table.shadow};
  max-width: 100%;
  margin-bottom: 10px;
  
  @media(max-width: ${mediaSize.tablet}) {
    ${TaskResponsiblePerson} {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/tasks-list/task/styled-components.js